import {
  Button,
} from 'antd';
import { IoClose } from 'react-icons/io5';
import { GoSync } from 'react-icons/go';
import { DisplaySeatDTO } from '../models/seat';
import CouponDTO from '../types/Coupon';

interface NumeratedOrderDetailsProps {
  displaySeats: Array<DisplaySeatDTO>,
  onSeatsUpdate: (selectedSeats: DisplaySeatDTO[]) => void,
  isLoading?: boolean;
  coupon?: CouponDTO;
}

const NumeratedOrderDetails = ({
  displaySeats, onSeatsUpdate, isLoading, coupon,
}: NumeratedOrderDetailsProps) => {
  const total = displaySeats.reduce((a, b) => a + b.ticket_price, 0);

  const deleteSelected = (seatId: string | number) => {
    const updatedSeats = displaySeats.filter((seat) => seat.id !== seatId);
    onSeatsUpdate(updatedSeats);
  };

  return (
    <div className='overflow-hidden rounded-3xl'>
      <div className='text-lg font-medium p-2 glass-surface text-text-primary mb-2 text-center'>Detalle de compra</div>
      <div className='rounded-3xl overflow-hidden'>
        <div className='bg-surface-secondary text-text-primary px-4 py-3 text-sm font-medium grid grid-cols-7'>
          <div className='col-span-3'>Sector</div>
          <div className='col-span-3'>Lugar</div>
        </div>
        <div className='bg-surface-base'>
          {displaySeats.map((seat) => (
            <div
              key={seat.id}
              className='grid grid-cols-7 items-center px-4 py-3 border-t border-border-secondary hover:bg-surface-tertiary'
            >
              <div className='flex flex-col text-left col-span-3'>
                <div className='text-sm font-medium text-text-primary'>Entrada</div>
                <div className='text-xs text-text-primary'>{seat.sector_name}</div>
              </div>
              <div className='text-left col-span-3'>
                <div className='text-sm text-text-primary'>{seat.seat_name}</div>
              </div>
              <div className='flex justify-end col-span-1 items-center justify-center'>
                {isLoading ? (
                  <GoSync className='animate-spin text-text-primary' />
                ) : (
                  <Button type='text' onClick={() => deleteSelected(seat.id)}>
                    <IoClose className='text-text-primary' size={24} />
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className='px-4 py-3 border-t border-border-secondary rounded-b-3xl bg-blur bg-opacity-medium'>
          <div className='flex justify-between'>
            <div className='text-start'>
              <div className='text-sm font-medium text-text-primary'>Subtotal</div>
            </div>
            <div className='text-start flex gap-2 items-center'>
              {coupon && <div className='text-xs font-medium text-text-secondary line-through'>${total}</div>}
              <div className='text-sm font-medium text-text-primary'>${coupon ? total - (total * (coupon.value)) : total}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NumeratedOrderDetails;
